import React from 'react';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import PropTypes from 'prop-types';

import { safeExtractFromObject } from '../helpers/helpers';

import Badge from '../common/badge';

import { BADGE_STYLE } from './menu.constants';

const PADDING_BY_LEVEL = [0, 8, 32];
const MAX_WIDTH_BY_LEVEL = [0, 196, 162];

function OntraccrMenuItem({
  key,
  text,
  level = 1,
  Icon,
  badgeCount,
  ...rest
}) {
  const isMenuOpen = useSelector((state) => state.menu.isMenuOpen);
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const hasRedesign = settings?.uxRedesignPt1;
  const textClass = hasRedesign ? 'menu-item-text-redesign' : null;
  const menuItemClass = hasRedesign ? `menu-item-redesign-${(level - 1)}` : 'ant-menu-item';
  const containerClass = hasRedesign ? 'menu-item-container-redesign' : null;
  let iconClass = hasRedesign ? 'menu-icon-redesign' : null;
  const badgeTop = hasRedesign ? 12 : '0.2em';

  const isSubmenu = level > 1;

  if (!isMenuOpen && !isSubmenu) {
    iconClass += ' menu-icon-redesign-closed';
  }

  const menuStyle = hasRedesign
    ? {
      marginTop: 0,
      marginBottom: 0,
    }
    : { paddingLeft: PADDING_BY_LEVEL[level] };

  const containerStyle = {
    ...menuStyle,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...(hasRedesign && {
      maxWidth: isMenuOpen || isSubmenu ? MAX_WIDTH_BY_LEVEL[level] : 80,
    }),
  };

  return (
    <Menu.Item
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      key={key}
      className={menuItemClass}
      style={menuStyle}
    >
      <div className={containerClass} style={containerStyle}>
        {Icon && <Icon className={iconClass} />}
        { (isMenuOpen || isSubmenu) && <span className={textClass}>{text}</span> }
        {badgeCount && (isMenuOpen || isSubmenu)
          ? <Badge count={badgeCount} style={{ ...BADGE_STYLE, top: badgeTop }} />
          : null}
      </div>
    </Menu.Item>
  );
}

OntraccrMenuItem.propTypes = {
  key: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  level: PropTypes.number,
  Icon: PropTypes.node.isRequired,
  badgeCount: PropTypes.number,
};

OntraccrMenuItem.defaultProps = {
  level: 1,
  badgeCount: 0,
};

export default OntraccrMenuItem;
